/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-27 17:07:17
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-28 15:33:17
 * @Description: 
 * @FilePath: \ICPSxin\src\api\GHnumber\cooperativeUnit.js
 */

import request from '@/utils/request'
//查询
export function queryList(data) {
    return request({
        url: '/icps/system/sign/dataCollection/collaborativeUnit/queryList',
        method: 'POST',
        data
    })
}

//查询列表
export function queryCollaborativeUnitBySuppler(data) {
    return request({
        url: '/icps/system/sign/dataCollection/collaborativeUnit/queryCollaborativeUnitBySuppler',
        method: 'POST',
        data
    })
}
//查询列表
export function queryAccountList(data) {
    return request({
        url: '/icps/system/sign/dataCollection/collaborativeUnit/queryAccountList',
        method: 'POST',
        data
    })
}

//保存协作单位
export function saveUnit(data) {
    return request({
        url: '/icps/system/sign/dataCollection/collaborativeUnit/saveOrUpdate',
        method: 'POST',
        data
    })
}
//b保存发票收取约定
export function saveAccount(data) {
    return request({
        url: '/icps/system/sign/dataCollection/collaborativeUnit/saveAccount',
        method: 'POST',
        data
    })
}
//删除
export function deleteOne(data) {
    return request({
        url: '/icps/system/sign/dataCollection/settlementAdjustment/deleteOne',
        method: 'POST',
        data
    })
}
